import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { UpdateAgentFirmProps } from './types';

type UpdateAgentFirmParams = {
  agentFirmId: string;
  data: UpdateAgentFirmProps;
};

export async function updateAgentFirm({
  agentFirmId,
  data,
}: UpdateAgentFirmParams) {
  const response = await fetcher(`${API_BASE_PATH}/${agentFirmId}`, {
    method: 'POST',
    body: data,
  });

  if (!response.ok) {
    const responseData = await response.json();
    return {
      success: false,
      error: responseData?.message || 'Failed to update agent firm',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
